import { useState, useEffect } from "react"
import { View, Linking, TouchableOpacity } from "react-native"
import { Body, H4 } from "@/components/standard/BFText"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import Square from "phosphor-react-native/src/icons/Square"
import CheckSquare from "phosphor-react-native/src/icons/CheckSquare"
import Coins from "phosphor-react-native/src/icons/Coins"
import { BFColors } from "@/constants/Colors"
import { useUser, useRewardsOptInMutation } from "@/queries/user"
import { $authToken } from "@/stores/auth"
import config from "@/config"

export const AvailableDiscountsSectionV2 = () => {
  const { data: user } = useUser()
  const userRewardsOptInStatus = user?.me?.rewardsOptInStatus ?? false
  const [showCheckbox, setShowCheckbox] = useState(true)
  const [isRewardsOptedIn, setIsRewardsOptedIn] = useState(
    userRewardsOptInStatus
  )
  const rewardsOptInMutation = useRewardsOptInMutation()

  const handleSeeHowItWorks = () => {
    void Linking.openURL(
      `${config.DASHBOARD_URL}/rewards/?token=${$authToken.get()}`
    )
  }

  useEffect(() => {
    if (user?.me) {
      setShowCheckbox(!user.me.rewardsOptInStatus)
    }
  }, [user?.me])

  const handleOptInToggle = () => {
    if (!isRewardsOptedIn) {
      setIsRewardsOptedIn(true)
      rewardsOptInMutation.mutate()
    }
  }

  let title = "Join Backflip Rewards"
  let description =
    "Opt in to earn up to 0.50% off your origination fees on eligible loans"
  if (!showCheckbox) {
    title = "You're earning Backflip Rewards"
    description =
      "Eligible discounts are automatically applied to your originaton fee"
  }

  return (
    <View className="grow">
      <View className="flex mb-2">
        <H4 className="text-midnight-blue">Available Discounts</H4>
      </View>
      <Horizontal className="rounded-lg p-4 px-5 border border-border bg-white">
        <Vertical className="flex-1 gap-2">
          <Horizontal className="gap-2 items-start">
            {showCheckbox && (
              <TouchableOpacity
                testID="rewards-opt-in-button"
                onPress={handleOptInToggle}
                disabled={isRewardsOptedIn}
              >
                {isRewardsOptedIn ? (
                  <CheckSquare
                    size={24}
                    color={BFColors.midnightBlue}
                    weight="regular"
                  />
                ) : (
                  <Square
                    size={24}
                    color={BFColors.midnightBlue}
                    weight="regular"
                  />
                )}
              </TouchableOpacity>
            )}
            <Vertical className="flex flex-1">
              <H4 className="text-midnight-blue flex-1 mb-1">{title}</H4>
              <Body className="text-midnight-blue">{description}</Body>
              {showCheckbox && (
                <TouchableOpacity
                  testID="see-how-it-works-button"
                  onPress={handleSeeHowItWorks}
                >
                  <Body className="text-calm-blue underline">
                    See how it works
                  </Body>
                </TouchableOpacity>
              )}
            </Vertical>
            <Coins size={32} color={BFColors.midnightBlue} weight="regular" />
          </Horizontal>
        </Vertical>
      </Horizontal>
    </View>
  )
}
